import React from "react";
import SpecialImage from "../assets/mission.jpg"; // Replace with your image
import "./Special.css";
import "../styles/main.css"; // Optional for custom styling

function Hero() {
  return (
    <section id ="about" className="special-section container-fluid py-5">
      <div className="container">
        <div className="row align-items-center">

          {/* Image LEFT */}
          <div className="col-12 col-md-6 text-center mb-4 mb-md-0 order-2 order-md-1">
            <img
              src={SpecialImage}
              alt="Our Mission"
              className="special-img img-fluid"
            />
          </div>

          {/* Text RIGHT */}
          <div className="col-12 col-md-6 text-center text-md-start order-1 order-md-2">
            <h2 className="special-title">Our Mission</h2>

            <div className="special-divider mx-md-0"></div>

            <p className="special-description">
              At EZ MedServ, our mission is to empower organizations and
              communities with innovative healthcare, business, consulting,
              outsourcing, and technology solutions. We strive to deliver
              excellence, foster growth, and build lasting partnerships through
              integrity, expertise, and a commitment to creating meaningful
              impact.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;